/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMedicine } from 'app/shared/model/medicine.model';
import { IConsumable } from 'app/shared/model/consumable.model';
import { IImplant } from 'app/shared/model/implant.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';

export interface IPharmacyLimit {
  id?: string;
  lowerLimit?: number | null;
  fmDays?: number | null;
  fmPercent?: number | null;
  smDays?: number | null;
  smPercent?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  drug?: IMedicine | null;
  consumable?: IConsumable | null;
  implant?: IImplant | null;
  pharmacy?: IPharmacy;
}

export const defaultValue: Readonly<IPharmacyLimit> = {
  active: false,
};
